import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, OnInit, ElementRef, ViewEncapsulation } from '@angular/core';
import { isNullOrUndefined } from '../../utils';

@Component({
  selector: 'loading-rect',
  host: {
        '[class]': 'animation',
        '[style.background]': 'color + " no-repeat"'
    },
  template: ``,
  styles: [`
    :host {
      display: inline-block;
      box-sizing: border-box;
      background: rgb(239, 241, 246) no-repeat;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class LoadingRectComponent implements OnInit, OnChanges {
  @Input() size: string | (string | number)[] = '100% 100%';
  @Input() color = 'rgb(239, 241, 246)';
  @Input() animation = 'pulse';

  constructor(private host: ElementRef<HTMLElement>) { }

  ngOnInit() {
    this.applyStyle();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.width || changes.height)
      this.applyStyle();
  }

  private applyStyle() {
    const hostEl = this.host?.nativeElement;

    if (!hostEl)
      return;

    let sizeParts: (string | number)[] = [];

    if (typeof this.size == 'string') {
      sizeParts = this.size.split(' ');
    }
    else {
      sizeParts = this.size;
    }

    if (sizeParts.length < 2) {
      sizeParts.length = 2;
    }

  hostEl.style.setProperty('width', this.getSizePropertyValue(sizeParts[0]));
  hostEl.style.setProperty('height', this.getSizePropertyValue(sizeParts[1]));
  }

  private getSizePropertyValue(size: string | number, defaultValue = '100%') {
    if (isNullOrUndefined(size))
      return defaultValue;

    if (typeof size == 'number')
      return `${size}px`;

    return size;
  }
}
